import { Modal } from '@components/core/modal.component.tsx';
import { FormLabel } from '@components/shared/form-label.component.tsx';
import { Input } from '@components/ui/input';
import { errorToast, successToast } from '@hooks/toast.hook.tsx';
import { cn } from '@lib/utils';
import type { FunctionComponent } from 'react';

interface ShareReferralLinkModalProps {
  isOpen: boolean;
  onClose: () => void;
  referralCode: string;
}

export const ShareReferralLinkModal: FunctionComponent<ShareReferralLinkModalProps> = (props) => {
  const { isOpen, referralCode, onClose } = props;

  const referralLink = `${window.location.origin}/?referrerCode=${encodeURIComponent(referralCode)}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      successToast({ description: 'Referral link copied to clipboard' });
    } catch (error) {
      errorToast({ description: 'Error copying referral link. Please try again later.' });
    }
  };

  return (
    <Modal
      centered
      footer={{
        leftButton: {
          onClick: onClose,
          children: 'Dismiss',
          variant: 'secondary',
        },
        rightButton: {
          onClick: handleCopy,
          children: 'Copy Link',
        },
      }}
      header={{
        title: 'Tyr Referrals',
      }}
      isOpen={isOpen}
      onClose={onClose}
      width="520px"
    >
      <div className="flex flex-col gap-4 py-2">
        <div className="px-3">
          <div className="space-y-2">
            <FormLabel
              label="Use this link to refer users to Tyr:"
              htmlFor="referral-link"
            />
            <div className="flex space-x-2">
              <Input
                id="referral-link"
                value={referralLink}
                readOnly
                onClick={handleCopy}
                className={cn(
                  'flex-1 cursor-pointer',
                  'hover:bg-gray-50 focus:bg-gray-50',
                  'transition-colors duration-200',
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
